import WorkspaceCard from '../../components/ListCard/WorkspaceCard';

const PublishedWorkspacesPage = () => {
  return (
    <>
      <div
        id="published_worskapces"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '-webkit-fill-available',
          backgroundColor: '#F8FAF9',
        }}
      >
        <div
          style={{
            backgroundSize: 'cover',
          }}
        >
          <div
            style={{
              margin: '30px 10%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <h1
              style={{
                color: '#2C3E37',
                fontWeight: 'bolder',
                fontSize: '36px',
              }}
            >
              Published Workspaces
            </h1>
            <p
              style={{
                color: '#2C3E37',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              {/* Interactive dashboards and web pages curated by data providers. */}
            </p>
          </div>
        </div>
        <div
          style={{
            backgroundColor: '#CEDBD6',
            backgroundSize: 'cover',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',

            // padding: '35px',
          }}
        >
          <div
            style={{
              margin: '30px 10%',
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
            }}
          >
            <WorkspaceCard
              title={'IFPRS Data Processing for Interagency Tracking System '}
              url={
                'https://www.wildfirecommons.org/workspaces/298d8974-a3a9-4cb8-98b3-16edbd9deb74'
              }
            />
            <WorkspaceCard
              title={'CLM AI Agent'}
              url={
                'https://nationaldataplatform.org/workspaces/0b4c30c0-3d27-47b8-892e-6dded158fa1c'
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default PublishedWorkspacesPage;
